module.exports = __webpack_public_path__ + "static/img/inviteVouchers.f440551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteVouchers.png
// module id = 3RtV
// module chunks = 2